import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "border p-6 rounded-2xl mt-5" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-5" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4301_3087)\"><path d=\"M8 16C12.4172 16 16 12.4172 16 8C16 3.58285 12.4172 0 8 0C3.58285 0 0 3.58285 0 8C0 12.4172 3.58285 16 8 16ZM7.42855 3.42858C7.42855 3.11428 7.6857 2.85713 8 2.85713C8.3143 2.85713 8.57145 3.11428 8.57145 3.42858V7.72572L11.2143 9.84001C11.46 10.0372 11.5 10.3971 11.3029 10.6429C11.1914 10.7829 11.0257 10.8571 10.8571 10.8571C10.7314 10.8571 10.6057 10.8171 10.5 10.7314L7.64288 8.44573C7.50859 8.33714 7.4286 8.1743 7.4286 8V3.42858H7.42855Z\" fill=\"#3B82F6\"></path></g><defs><clipPath id=\"clip0_4301_3087\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_5 = { class: "text-sm font-semibold uppercase" }
const _hoisted_6 = { class: "flex items-center gap-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.833 5.83333L15.1102 15.9521C15.0479 16.8243 14.3222 17.5 13.4478 17.5H6.55154C5.67714 17.5 4.95141 16.8243 4.88911 15.9521L4.16634 5.83333M8.33301 9.16667V14.1667M11.6663 9.16667V14.1667M12.4997 5.83333V3.33333C12.4997 2.8731 12.1266 2.5 11.6663 2.5H8.33301C7.87277 2.5 7.49967 2.8731 7.49967 3.33333V5.83333M3.33301 5.83333H16.6663",
  stroke: "#DC2626",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mt-5 flex items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 text-sm\" style=\"color:#0F172A;\"><div>Выберите интервал тайм-слота</div><svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4301_3109)\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect><path d=\"M5.00099 0C2.24048 0 0.000976562 2.23668 0.000976562 4.99737C0.000976562 7.76071 2.24048 10 5.00097 10C7.76298 10 10.0006 7.76068 10.0006 4.99737C10.0006 2.23668 7.76298 0 5.00099 0ZM5.35729 7.77951C5.24116 7.88285 5.10658 7.93479 4.95412 7.93479C4.79638 7.93479 4.65879 7.88378 4.54134 7.78157C4.42371 7.67954 4.36478 7.5367 4.36478 7.35316C4.36478 7.19035 4.42181 7.05332 4.53551 6.94226C4.6492 6.8312 4.78867 6.77568 4.95412 6.77568C5.11693 6.77568 5.25397 6.8312 5.36521 6.94226C5.47626 7.05332 5.53198 7.19033 5.53198 7.35316C5.53177 7.53406 5.4736 7.67619 5.35729 7.77951ZM6.8053 4.18969C6.71608 4.35514 6.61012 4.49781 6.48721 4.6181C6.36466 4.73837 6.14427 4.94052 5.82615 5.22474C5.73844 5.30493 5.66786 5.37532 5.61497 5.43592C5.56208 5.49673 5.52255 5.55223 5.49676 5.60269C5.47078 5.65312 5.45084 5.70358 5.43671 5.75401C5.42259 5.80426 5.40133 5.89293 5.37253 6.01959C5.3236 6.28838 5.16982 6.42276 4.91138 6.42276C4.77698 6.42276 4.66405 6.3789 4.572 6.291C4.48033 6.2031 4.43459 6.07266 4.43459 5.8995C4.43459 5.68249 4.46829 5.49444 4.53548 5.3354C4.60231 5.17634 4.69172 5.03688 4.80277 4.9166C4.91402 4.79633 5.06383 4.65365 5.25262 4.4882C5.41807 4.34345 5.5376 4.23429 5.61119 4.16068C5.68497 4.0869 5.74691 4.00484 5.79716 3.91448C5.8478 3.82395 5.87265 3.72588 5.87265 3.61992C5.87265 3.41307 5.79605 3.23877 5.64208 3.09666C5.4883 2.95456 5.28991 2.8834 5.04691 2.8834C4.76251 2.8834 4.5532 2.95511 4.4188 3.09854C4.28441 3.24197 4.17092 3.45315 4.07774 3.73229C3.98965 4.02443 3.82288 4.17047 3.57762 4.17047C3.43287 4.17047 3.31072 4.11946 3.21115 4.01744C3.11177 3.91541 3.06207 3.80493 3.06207 3.68598C3.06207 3.44053 3.14094 3.1917 3.2985 2.93967C3.45623 2.68764 3.68624 2.47889 3.9887 2.31362C4.29098 2.14817 4.64392 2.06535 5.04691 2.06535C5.42166 2.06535 5.75238 2.13461 6.03923 2.27296C6.32609 2.41111 6.5478 2.59916 6.70422 2.83706C6.86046 3.07478 6.93875 3.33323 6.93875 3.61237C6.93912 3.83168 6.89452 4.02424 6.8053 4.18969Z\" fill=\"#475569\"></path></g><defs><clipPath id=\"clip0_4301_3109\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"my-5 w-full\" style=\"background-color:#F1F5F9;height:2px;\"></div><div class=\"flex items-center justify-between\"><div class=\"flex items-center gap-2 text-sm\" style=\"color:#0F172A;\"><div>Укажите доступный ресурс по дням недели</div><svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4301_3109)\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect><path d=\"M5.00099 0C2.24048 0 0.000976562 2.23668 0.000976562 4.99737C0.000976562 7.76071 2.24048 10 5.00097 10C7.76298 10 10.0006 7.76068 10.0006 4.99737C10.0006 2.23668 7.76298 0 5.00099 0ZM5.35729 7.77951C5.24116 7.88285 5.10658 7.93479 4.95412 7.93479C4.79638 7.93479 4.65879 7.88378 4.54134 7.78157C4.42371 7.67954 4.36478 7.5367 4.36478 7.35316C4.36478 7.19035 4.42181 7.05332 4.53551 6.94226C4.6492 6.8312 4.78867 6.77568 4.95412 6.77568C5.11693 6.77568 5.25397 6.8312 5.36521 6.94226C5.47626 7.05332 5.53198 7.19033 5.53198 7.35316C5.53177 7.53406 5.4736 7.67619 5.35729 7.77951ZM6.8053 4.18969C6.71608 4.35514 6.61012 4.49781 6.48721 4.6181C6.36466 4.73837 6.14427 4.94052 5.82615 5.22474C5.73844 5.30493 5.66786 5.37532 5.61497 5.43592C5.56208 5.49673 5.52255 5.55223 5.49676 5.60269C5.47078 5.65312 5.45084 5.70358 5.43671 5.75401C5.42259 5.80426 5.40133 5.89293 5.37253 6.01959C5.3236 6.28838 5.16982 6.42276 4.91138 6.42276C4.77698 6.42276 4.66405 6.3789 4.572 6.291C4.48033 6.2031 4.43459 6.07266 4.43459 5.8995C4.43459 5.68249 4.46829 5.49444 4.53548 5.3354C4.60231 5.17634 4.69172 5.03688 4.80277 4.9166C4.91402 4.79633 5.06383 4.65365 5.25262 4.4882C5.41807 4.34345 5.5376 4.23429 5.61119 4.16068C5.68497 4.0869 5.74691 4.00484 5.79716 3.91448C5.8478 3.82395 5.87265 3.72588 5.87265 3.61992C5.87265 3.41307 5.79605 3.23877 5.64208 3.09666C5.4883 2.95456 5.28991 2.8834 5.04691 2.8834C4.76251 2.8834 4.5532 2.95511 4.4188 3.09854C4.28441 3.24197 4.17092 3.45315 4.07774 3.73229C3.98965 4.02443 3.82288 4.17047 3.57762 4.17047C3.43287 4.17047 3.31072 4.11946 3.21115 4.01744C3.11177 3.91541 3.06207 3.80493 3.06207 3.68598C3.06207 3.44053 3.14094 3.1917 3.2985 2.93967C3.45623 2.68764 3.68624 2.47889 3.9887 2.31362C4.29098 2.14817 4.64392 2.06535 5.04691 2.06535C5.42166 2.06535 5.75238 2.13461 6.03923 2.27296C6.32609 2.41111 6.5478 2.59916 6.70422 2.83706C6.86046 3.07478 6.93875 3.33323 6.93875 3.61237C6.93912 3.83168 6.89452 4.02424 6.8053 4.18969Z\" fill=\"#475569\"></path></g><defs><clipPath id=\"clip0_4301_3109\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect></clipPath></defs></svg></div></div>", 2)
const _hoisted_14 = { class: "mt-5" }
const _hoisted_15 = { class: "grid grid-cols-7 gap-5" }
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Понедельник", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex flex-col gap-1" }
const _hoisted_21 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Вторник", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "flex flex-col gap-1" }
const _hoisted_25 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Среда", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "flex flex-col gap-1" }
const _hoisted_29 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Четверг", -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "flex flex-col gap-1" }
const _hoisted_33 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "Пятница", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "flex flex-col gap-1" }
const _hoisted_37 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Суббота", -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "flex flex-col gap-1" }
const _hoisted_41 = {
  class: "text-sm",
  style: {"color":"#475569"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "Воскресенье", -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"my-5 w-full\" style=\"background-color:#F1F5F9;height:2px;\"></div><div class=\"flex items-center justify-between\"><div class=\"flex items-center gap-2 text-sm\" style=\"color:#0F172A;\"><div>Укажите секторы доступности тайм-слота</div><svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4301_3109)\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect><path d=\"M5.00099 0C2.24048 0 0.000976562 2.23668 0.000976562 4.99737C0.000976562 7.76071 2.24048 10 5.00097 10C7.76298 10 10.0006 7.76068 10.0006 4.99737C10.0006 2.23668 7.76298 0 5.00099 0ZM5.35729 7.77951C5.24116 7.88285 5.10658 7.93479 4.95412 7.93479C4.79638 7.93479 4.65879 7.88378 4.54134 7.78157C4.42371 7.67954 4.36478 7.5367 4.36478 7.35316C4.36478 7.19035 4.42181 7.05332 4.53551 6.94226C4.6492 6.8312 4.78867 6.77568 4.95412 6.77568C5.11693 6.77568 5.25397 6.8312 5.36521 6.94226C5.47626 7.05332 5.53198 7.19033 5.53198 7.35316C5.53177 7.53406 5.4736 7.67619 5.35729 7.77951ZM6.8053 4.18969C6.71608 4.35514 6.61012 4.49781 6.48721 4.6181C6.36466 4.73837 6.14427 4.94052 5.82615 5.22474C5.73844 5.30493 5.66786 5.37532 5.61497 5.43592C5.56208 5.49673 5.52255 5.55223 5.49676 5.60269C5.47078 5.65312 5.45084 5.70358 5.43671 5.75401C5.42259 5.80426 5.40133 5.89293 5.37253 6.01959C5.3236 6.28838 5.16982 6.42276 4.91138 6.42276C4.77698 6.42276 4.66405 6.3789 4.572 6.291C4.48033 6.2031 4.43459 6.07266 4.43459 5.8995C4.43459 5.68249 4.46829 5.49444 4.53548 5.3354C4.60231 5.17634 4.69172 5.03688 4.80277 4.9166C4.91402 4.79633 5.06383 4.65365 5.25262 4.4882C5.41807 4.34345 5.5376 4.23429 5.61119 4.16068C5.68497 4.0869 5.74691 4.00484 5.79716 3.91448C5.8478 3.82395 5.87265 3.72588 5.87265 3.61992C5.87265 3.41307 5.79605 3.23877 5.64208 3.09666C5.4883 2.95456 5.28991 2.8834 5.04691 2.8834C4.76251 2.8834 4.5532 2.95511 4.4188 3.09854C4.28441 3.24197 4.17092 3.45315 4.07774 3.73229C3.98965 4.02443 3.82288 4.17047 3.57762 4.17047C3.43287 4.17047 3.31072 4.11946 3.21115 4.01744C3.11177 3.91541 3.06207 3.80493 3.06207 3.68598C3.06207 3.44053 3.14094 3.1917 3.2985 2.93967C3.45623 2.68764 3.68624 2.47889 3.9887 2.31362C4.29098 2.14817 4.64392 2.06535 5.04691 2.06535C5.42166 2.06535 5.75238 2.13461 6.03923 2.27296C6.32609 2.41111 6.5478 2.59916 6.70422 2.83706C6.86046 3.07478 6.93875 3.33323 6.93875 3.61237C6.93912 3.83168 6.89452 4.02424 6.8053 4.18969Z\" fill=\"#475569\"></path></g><defs><clipPath id=\"clip0_4301_3109\"><rect width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"></rect></clipPath></defs></svg></div></div>", 2)
const _hoisted_46 = { class: "mt-5" }
const _hoisted_47 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "При получении секторов произошла ошибка", -1)
const _hoisted_49 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_50 = {
  key: 1,
  class: "grid grid-cols-5",
  style: {"gap":"6.5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_time_slot_badge = _resolveComponent("time-slot-badge")!
  const _component_time_slot_time_range = _resolveComponent("time-slot-time-range")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_time_slot_sector_checkbox = _resolveComponent("time-slot-sector-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isMain)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Основной тайм-слот")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Внутренний тайм-слот №" + _toDisplayString(_ctx.index + 1), 1)
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.disabled && !_ctx.isMain)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              class: "cursor-pointer",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDeleteSlot && _ctx.onDeleteSlot(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createVNode(_component_checkbox, {
          label: "Активен",
          disabled: _ctx.disabled,
          value: _ctx.isActive,
          onClick: _ctx.onToggleActive
        }, null, 8, ["disabled", "value", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", null, [
        (_ctx.timeFrom || _ctx.timeTo)
          ? (_openBlock(), _createBlock(_component_time_slot_badge, {
              key: 0,
              "time-from": _ctx.timeFrom,
              "time-to": _ctx.timeTo
            }, null, 8, ["time-from", "time-to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_time_slot_time_range, {
        disabled: _ctx.disabled,
        "time-from": _ctx.timeFrom,
        "time-to": _ctx.timeTo,
        "is-main": _ctx.isMain,
        "main-time-range": _ctx.mainTimeRange,
        "reserved-time-range": _ctx.reservedTimeRange,
        onTimeFrom: _ctx.onTimeFrom,
        onTimeTo: _ctx.onTimeTo,
        onChange: _ctx.onTimeSlotChange
      }, null, 8, ["disabled", "time-from", "time-to", "is-main", "main-time-range", "reserved-time-range", "onTimeFrom", "onTimeTo", "onChange"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[1])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[1].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[1].errors.length),
            "validation-errors": _ctx.capacities[1].errors,
            value: _ctx.capacities[1].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[1] || (_cache[1] = (value) => _ctx.updateCapacity({ weekday: 1, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[2])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[2].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[2].errors.length),
            "validation-errors": _ctx.capacities[2].errors,
            value: _ctx.capacities[2].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[2] || (_cache[2] = (value) => _ctx.updateCapacity({ weekday: 2, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[3])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[3].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[3].errors.length),
            "validation-errors": _ctx.capacities[3].errors,
            value: _ctx.capacities[3].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[3] || (_cache[3] = (value) => _ctx.updateCapacity({ weekday: 3, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[4])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[4].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[4].errors.length),
            "validation-errors": _ctx.capacities[4].errors,
            value: _ctx.capacities[4].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[4] || (_cache[4] = (value) => _ctx.updateCapacity({ weekday: 4, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[5])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[5].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[5].errors.length),
            "validation-errors": _ctx.capacities[5].errors,
            value: _ctx.capacities[5].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[5] || (_cache[5] = (value) => _ctx.updateCapacity({ weekday: 5, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[6])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[6].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[6].errors.length),
            "validation-errors": _ctx.capacities[6].errors,
            value: _ctx.capacities[6].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[6] || (_cache[6] = (value) => _ctx.updateCapacity({ weekday: 6, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            (!_ctx.isMain)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                  _createTextVNode("Доступно: "),
                  (_ctx.resourceLimits[0])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.resourceLimits[0].limit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_the_input, {
            "is-invalid": Boolean(_ctx.capacities[0].errors.length),
            "validation-errors": _ctx.capacities[0].errors,
            value: _ctx.capacities[0].amount,
            disabled: _ctx.disabled,
            "onUpdate:value": _cache[7] || (_cache[7] = (value) => _ctx.updateCapacity({ weekday: 0, amount: value }))
          }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"])
        ])
      ])
    ]),
    _hoisted_44,
    _createElementVNode("div", _hoisted_46, [
      (_ctx.sectorsLoading || _ctx.sectorsFailed || _ctx.sectors.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            (_ctx.sectorsLoading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.sectorsFailed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_48,
                    _createVNode(_component_the_button, {
                      type: "button",
                      class: "small primary",
                      onClick: _ctx.onReloadSectors
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.sectors.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Список пуст"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors, (sector) => {
              return (_openBlock(), _createBlock(_component_time_slot_sector_checkbox, {
                key: sector.id,
                sector: sector,
                disabled: _ctx.disabled,
                checked: _ctx.isSectorSelected(sector),
                onClick: _ctx.onSectorToggle
              }, null, 8, ["sector", "disabled", "checked", "onClick"]))
            }), 128))
          ]))
    ])
  ]))
}